import Component from '@bythepixel/component-loader';

// One-time guard: a page can now hold several contact forms (inline hero form, the
// modal, future blocks). They share a single auto-geolocation instead of each firing
// its own ipinfo + nearest-dealer lookup. The result is broadcast to every form via
// the `dealer-locator:located` (lat/lng) and `dealer-locator:select` (dealer) events.
let autoLocateStarted = false;

export default class DealerLocatorForm extends Component {
  static selector = '[comp-dealer-locator-form]';

  constructor(...args) {
    super(...args);

    this.latInput = this.$container.querySelector('[name="latitude"]');
    this.lngInput = this.$container.querySelector('[name="longitude"]');
    this.dealerIdInput = this.$container.querySelector('[name="dealer_id"]');

    this.dealerCard = this.$container.querySelector('[comp-dealer-card]');
    this.dealerName = this.$container.querySelector('[comp-dealer-name]');
    this.dealerAddress = this.$container.querySelector('[comp-dealer-address]');
    this.dealerCity = this.$container.querySelector('[comp-dealer-city]');

    this.changeBtn = this.$container.querySelector('[comp-dealer-change]');

    this.events();

    // If the server restored a prior selection via old() on submission failure,
    // skip auto-locating so we don't overwrite the user's choice.
    if (this.dealerIdInput && this.dealerIdInput.value) {
      if (this.dealerCard) this.dealerCard.style.display = '';
    } else {
      DealerLocatorForm.autoLocate();
    }
  }

  events() {
    if (this.changeBtn) {
      this.changeBtn.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('dealer-locator:open'));
      });
    }

    // Located (auto-geolocation) — fill the hidden lat/lng fallback on every form.
    document.addEventListener('dealer-locator:located', (e) => {
      if (this.latInput) this.latInput.value = e.detail.lat;
      if (this.lngInput) this.lngInput.value = e.detail.lng;
    });

    // A dealer was chosen (auto-located or picked) — show it on every form.
    document.addEventListener('dealer-locator:select', (e) => {
      this.showDealerCard(e.detail.dealer);
    });
  }

  /**
   * Page-level geolocation, run a single time regardless of how many forms exist.
   * Broadcasts the user location and nearest dealer so every form stays in sync.
   */
  static autoLocate() {
    if (autoLocateStarted) return;
    autoLocateStarted = true;

    const token = (window.CIMARRON && window.CIMARRON.env && window.CIMARRON.env.ipInfoToken) || '';

    fetch(`https://ipinfo.io/json?token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.loc) return null;

        const [lat, lng] = data.loc.split(',');

        window.CIMARRON = window.CIMARRON || {};
        window.CIMARRON.userLocation = { lat, lng };

        document.dispatchEvent(new CustomEvent('dealer-locator:located', { detail: { lat, lng } }));

        return fetch(`/api/nearest-dealer?lat=${lat}&lng=${lng}`)
          .then((res) => res.json())
          .then((result) => {
            if (result.found && result.dealer) {
              document.dispatchEvent(new CustomEvent('dealer-locator:select', { detail: { dealer: result.dealer } }));
            }
          });
      })
      .catch(() => {});
  }

  showDealerCard(dealer) {
    if (this.dealerIdInput) this.dealerIdInput.value = dealer.id;
    if (this.dealerName) this.dealerName.textContent = dealer.title;
    if (this.dealerAddress) this.dealerAddress.textContent = dealer.address;
    if (this.dealerCity) this.dealerCity.textContent = `${dealer.city}, ${dealer.state} ${dealer.zip}`;
    if (this.dealerCard) this.dealerCard.style.display = '';
  }
}
